import { AfterViewInit, Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { AutocompleteService } from '../services';

export interface IAutocompletePayload {
    houseNumber: number;
    address: string;
    city: string;
    state: string;
    zip: string;
}

@Directive({
    selector: '[propertyAutocomplete]'
})
export class PropertyAutocompleteDirective implements AfterViewInit {
    @Output() addressChangedByAutocomplete: EventEmitter<IAutocompletePayload> = new EventEmitter<IAutocompletePayload>();

    private el: HTMLInputElement;
    private autocomplete: any;

    constructor(
        private elementRef: ElementRef,
        private autocompleteService: AutocompleteService
    ) {
        this.el = this.elementRef.nativeElement;
        this.addressChanged = this.addressChanged.bind(this);
    }

    ngAfterViewInit() {
        // 1s seems to be the sweetspot to avoid the `Not an HTML element` error message
        setTimeout(() => {
            this.autocomplete = this.autocompleteService.getPropertyAutocomplete(this.el.querySelector('input') as HTMLInputElement);
            this.autocomplete.setFields(['address_components', 'adr_address']);
            this.autocomplete.addListener('place_changed', this.addressChanged);
        }, 1000);
    }

    getTypeFromAddressComponents(components: any, type: string, resultVersion: string) {
        return components.filter((component: any) => component.types.indexOf(type) === 0).map((item: any) => item[resultVersion]).pop() || null;
    }

    addressChanged() {
        // const state = this.state;
        const place = this.autocomplete.getPlace();
        const comps = place.address_components;

        if (comps) {
            const houseNumber = this.getTypeFromAddressComponents(comps, 'street_number', 'long_name');
            const address = this.getTypeFromAddressComponents(comps, 'route', 'long_name');
            const city = this.getTypeFromAddressComponents(comps, 'locality', 'long_name');
            const state = this.getTypeFromAddressComponents(comps, 'administrative_area_level_1', 'short_name');
            const zip = this.getTypeFromAddressComponents(comps, 'postal_code', 'long_name');

            this.addressChangedByAutocomplete.emit({
                houseNumber: houseNumber,
                address: address,
                city: city,
                state: state,
                zip: zip
            });
        }
    }
}
